import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const rocheLinkListCss = ":host{display:block;margin-top:3rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host ::slotted([slot=links]){display:flex;flex-direction:column}";
const RocheLinkListStyle0 = rocheLinkListCss;

const RocheLinkList$1 = /*@__PURE__*/ proxyCustomElement(class RocheLinkList extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h(Host, { key: '996d546578968405b03d33ecbe49c3735d65bcec' }, h("slot", { key: '08836e80ada2f42a034edc374081ee3f784a19f3', name: "links" })));
    }
    static get style() { return RocheLinkListStyle0; }
}, [1, "roche-link-list"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-link-list"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-link-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheLinkList$1);
            }
            break;
    } });
}

const RocheLinkList = RocheLinkList$1;
const defineCustomElement = defineCustomElement$1;

export { RocheLinkList, defineCustomElement };

//# sourceMappingURL=roche-link-list.js.map